// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2710%27 viewBox=%270 0 12 10%27 fill=%27none%27%3E%3Cpath d=%27M1 5L4.33333 8L11 1%27 stroke=%27white%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27 fill=%27none%27%3E%3Ccircle cx=%274%27 cy=%274%27 r=%274%27 fill=%27white%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(46 144 250 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(46 144 250 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e9eaeb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #a4a7ae; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  body {
  font-family: 'Inter', sans-serif;
  font-size: 0.875rem;
  line-height: 1.25rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
  @media (min-width: 992px) {

  body {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
  ::selection {
  --tw-bg-opacity: 1;
  background-color: rgb(56 107 158 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
  h1 {
  margin-bottom: 1rem;
  font-size: 2.25rem;
  line-height: 2.5rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}
  @media (min-width: 768px) {

  h1 {
    margin-bottom: 1.25rem;
  }
}
  @media (min-width: 992px) {

  h1 {
    font-size: 3rem;
    line-height: 1;
  }
}
  @media (min-width: 1240px) {

  h1 {
    font-size: 3.75rem;
    line-height: 1;
  }
}
  h2 {
  margin-bottom: 0.75rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}
  @media (min-width: 768px) {

  h2 {
    margin-bottom: 1rem;
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
  @media (min-width: 992px) {

  h2 {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
}
  h3 {
  margin-bottom: 0.625rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
}
  @media (min-width: 768px) {

  h3 {
    margin-bottom: 1rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
  @media (min-width: 992px) {

  h3 {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
  h4 {
  margin-bottom: 0.75rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
}
  @media (min-width: 768px) {

  h4 {
    margin-bottom: 0.875rem;
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
  @media (min-width: 992px) {

  h4 {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
  h5 {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
}
  @media (min-width: 768px) {

  h5 {
    margin-bottom: 0.75rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
  @media (min-width: 992px) {

  h5 {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
  h6 {
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
}
  @media (min-width: 768px) {

  h6 {
    margin-bottom: 0.75rem;
  }
}
  @media (min-width: 992px) {

  h6 {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
  p {
  margin-bottom: 0.5rem;
}
  @media (min-width: 768px) {

  p {
    margin-bottom: 0.75rem;
  }
}
  a,
  button {
  transition-property: all;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
  .btn-regular {
  min-height: 44px;
  padding-left: 18px;
  padding-right: 18px;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
}
  .btn-xl {
  min-height: 60px;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.75rem;
}
  .btn-lg {
  min-height: 48px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
}
  .btn-sm {
  min-height: 40px;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
}
  .btn-xs {
  min-height: 36px;
  padding-left: 14px;
  padding-right: 14px;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25rem;
}
  ::-webkit-scrollbar {
  height: 0.375rem;
  width: 0.375rem;
}
  ::-webkit-scrollbar-track {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(132 202 255 / var(--tw-border-opacity, 1));
}
  ::-webkit-scrollbar-thumb {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(65 131 198 / var(--tw-bg-opacity, 1));
}
  ::-webkit-scrollbar-thumb:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(86 151 217 / var(--tw-bg-opacity, 1));
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {

  .container {
    max-width: 576px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 992px) {

  .container {
    max-width: 992px;
  }
}
@media (min-width: 1240px) {

  .container {
    max-width: 1240px;
  }
}
@media (min-width: 1476px) {

  .container {
    max-width: 1476px;
  }
}
.container {
  max-width: 100%;
}
@media (min-width: 768px) {

  .container {
    max-width: 100%;
  }
}
@media (min-width: 992px) {

  .container {
    max-width: 100%;
  }
}
@media (min-width: 1240px) {

  .container {
    max-width: 100%;
  }
}
@media (min-width: 1476px) {

  .container {
    max-width: 100%;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-y-1\\/2 {
  top: 50%;
  bottom: 50%;
}
.-right-3 {
  right: -0.75rem;
}
.-top-3 {
  top: -0.75rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-full {
  bottom: 100%;
}
.end-0 {
  inset-inline-end: 0px;
}
.end-3 {
  inset-inline-end: 0.75rem;
}
.end-4 {
  inset-inline-end: 1rem;
}
.end-5 {
  inset-inline-end: 1.25rem;
}
.left-0 {
  left: 0px;
}
.left-full {
  left: 100%;
}
.right-0 {
  right: 0px;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.start-0 {
  inset-inline-start: 0px;
}
.start-1 {
  inset-inline-start: 0.25rem;
}
.start-3 {
  inset-inline-start: 0.75rem;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-2\\/4 {
  top: 50%;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-48 {
  top: 12rem;
}
.top-8 {
  top: 2rem;
}
.top-\\[137px\\] {
  top: 137px;
}
.top-\\[143px\\] {
  top: 143px;
}
.top-\\[144px\\] {
  top: 144px;
}
.top-\\[148px\\] {
  top: 148px;
}
.top-\\[22px\\] {
  top: 22px;
}
.top-\\[29px\\] {
  top: 29px;
}
.top-\\[358px\\] {
  top: 358px;
}
.top-\\[474px\\] {
  top: 474px;
}
.top-\\[72px\\] {
  top: 72px;
}
.top-\\[73px\\] {
  top: 73px;
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.z-0 {
  z-index: 0;
}
.z-1 {
  z-index: 1;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-4 {
  z-index: 4;
}
.z-40 {
  z-index: 40;
}
.z-5 {
  z-index: 5;
}
.z-50 {
  z-index: 50;
}
.z-\\[51\\] {
  z-index: 51;
}
.z-\\[99999999\\] {
  z-index: 99999999;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-5 {
  grid-column: span 5 / span 5;
}
.col-span-9 {
  grid-column: span 9 / span 9;
}
.float-right {
  float: right;
}
.\\!m-auto {
  margin: auto !important;
}
.m-0 {
  margin: 0px;
}
.m-2 {
  margin: 0.5rem;
}
.m-8 {
  margin: 2rem;
}
.\\!-mx-0 {
  margin-left: -0px !important;
  margin-right: -0px !important;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-1\\.5 {
  margin-left: -0.375rem;
  margin-right: -0.375rem;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.-my-1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-\\[-10rem\\] {
  margin-left: -10rem;
  margin-right: -10rem;
}
.mx-\\[5px\\] {
  margin-left: 5px;
  margin-right: 5px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.\\!mb-0 {
  margin-bottom: 0px !important;
}
.\\!mb-2 {
  margin-bottom: 0.5rem !important;
}
.\\!mb-4 {
  margin-bottom: 1rem !important;
}
.-mt-4 {
  margin-top: -1rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.me-3 {
  margin-inline-end: 0.75rem;
}
.me-4 {
  margin-inline-end: 1rem;
}
.ml-0 {
  margin-left: 0px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-8 {
  margin-left: 2rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.ms-0\\.5 {
  margin-inline-start: 0.125rem;
}
.ms-1 {
  margin-inline-start: 0.25rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.ms-auto {
  margin-inline-start: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}
.size-5 {
  width: 1.25rem;
  height: 1.25rem;
}
.size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
.\\!h-screen {
  height: 100vh !important;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[60vh\\] {
  height: 60vh;
}
.h-\\[calc\\(100dvh-105px\\)\\] {
  height: calc(100dvh - 105px);
}
.h-\\[calc\\(100dvh-150px\\)\\] {
  height: calc(100dvh - 150px);
}
.h-\\[calc\\(100dvh-155px\\)\\] {
  height: calc(100dvh - 155px);
}
.h-\\[calc\\(100dvh-190px\\)\\] {
  height: calc(100dvh - 190px);
}
.h-\\[calc\\(100dvh-200px\\)\\] {
  height: calc(100dvh - 200px);
}
.h-\\[calc\\(100dvh-264px\\)\\] {
  height: calc(100dvh - 264px);
}
.h-\\[calc\\(100dvh-280px\\)\\] {
  height: calc(100dvh - 280px);
}
.h-\\[calc\\(100dvh-300px\\)\\] {
  height: calc(100dvh - 300px);
}
.h-\\[calc\\(100vh-200px\\)\\] {
  height: calc(100vh - 200px);
}
.h-\\[calc\\(100vh-250px\\)\\] {
  height: calc(100vh - 250px);
}
.h-\\[calc\\(100vh-315px\\)\\] {
  height: calc(100vh - 315px);
}
.h-\\[calc\\(100vh-330px\\)\\] {
  height: calc(100vh - 330px);
}
.h-\\[calc\\(100vh-350px\\)\\] {
  height: calc(100vh - 350px);
}
.h-auto {
  height: auto;
}
.h-dvh {
  height: 100dvh;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-52 {
  max-height: 13rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[50vh\\] {
  max-height: 50vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.\\!min-h-0 {
  min-height: 0px !important;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-11 {
  min-height: 2.75rem;
}
.min-h-12 {
  min-height: 3rem;
}
.min-h-\\[12rem\\] {
  min-height: 12rem;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[440px\\] {
  min-height: 440px;
}
.min-h-\\[96px\\] {
  min-height: 96px;
}
.min-h-\\[calc\\(100dvh-150px\\)\\] {
  min-height: calc(100dvh - 150px);
}
.min-h-fit {
  min-height: fit-content;
}
.min-h-full {
  min-height: 100%;
}
.\\!w-48 {
  width: 12rem !important;
}
.\\!w-\\[50px\\] {
  width: 50px !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/12 {
  width: 41.666667%;
}
.w-52 {
  width: 13rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[1000px\\] {
  width: 1000px;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[1140px\\] {
  width: 1140px;
}
.w-\\[1320px\\] {
  width: 1320px;
}
.w-\\[15\\%\\] {
  width: 15%;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[240px\\] {
  width: 240px;
}
.w-\\[25\\%\\] {
  width: 25%;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[312px\\] {
  width: 312px;
}
.w-\\[350px\\] {
  width: 350px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[512px\\] {
  width: 512px;
}
.w-\\[560px\\] {
  width: 560px;
}
.w-\\[720px\\] {
  width: 720px;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[calc\\(100\\%-24px\\)\\] {
  width: calc(100% - 24px);
}
.w-\\[calc\\(100\\%-40px\\)\\] {
  width: calc(100% - 40px);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-24 {
  min-width: 6rem;
}
.min-w-32 {
  min-width: 8rem;
}
.min-w-36 {
  min-width: 9rem;
}
.min-w-40 {
  min-width: 10rem;
}
.min-w-44 {
  min-width: 11rem;
}
.min-w-48 {
  min-width: 12rem;
}
.min-w-6 {
  min-width: 1.5rem;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[110px\\] {
  min-width: 110px;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[320px\\] {
  min-width: 320px;
}
.min-w-\\[60px\\] {
  min-width: 60px;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-32 {
  max-width: 8rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-\\[10ch\\] {
  max-width: 10ch;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[512px\\] {
  max-width: 512px;
}
.max-w-\\[5px\\] {
  max-width: 5px;
}
.max-w-\\[70\\%\\] {
  max-width: 70%;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-fit {
  max-width: fit-content;
}
.max-w-full {
  max-width: 100%;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.table-fixed {
  table-layout: fixed;
}
.border-separate {
  border-collapse: separate;
}
.border-spacing-y-2 {
  --tw-border-spacing-y: 0.5rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-center {
  transform-origin: center;
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2\\/4 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[calc\\(100\\%\\+1px\\)\\] {
  --tw-translate-x: calc(100% + 1px);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[calc\\(100\\%-17px\\)\\] {
  --tw-translate-x: calc(100% - 17px);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.\\!cursor-not-allowed {
  cursor: not-allowed !important;
}
.cursor-col-resize {
  cursor: col-resize;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-text {
  cursor: text;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.select-all {
  -webkit-user-select: all;
          user-select: all;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.list-disc {
  list-style-type: disc;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-\\[1fr\\2c auto\\] {
  grid-template-columns: 1fr auto;
}
.grid-cols-\\[1fr_1fr\\] {
  grid-template-columns: 1fr 1fr;
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(120px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(120px,1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-items-center {
  justify-items: center;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-divide-opacity, 1));
}
.divide-gray-500 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(113 118 128 / var(--tw-divide-opacity, 1));
}
.justify-self-start {
  justify-self: start;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-clip {
  overflow: clip;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.\\!whitespace-nowrap {
  white-space: nowrap !important;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.text-nowrap {
  text-wrap: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.\\!rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.\\!rounded-t-none {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-e-md {
  border-start-end-radius: 0.375rem;
  border-end-end-radius: 0.375rem;
}
.rounded-r-xl {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-br-none {
  border-bottom-right-radius: 0px;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-\\[3px\\] {
  border-width: 3px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-\\[3px\\] {
  border-bottom-width: 3px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.\\!border-error-600 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(217 45 32 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-gray-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(164 167 174 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#d92d20\\] {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity, 1));
}
.border-\\[currentcolor\\] {
  border-color: currentcolor;
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(209 233 255 / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(178 221 255 / var(--tw-border-opacity, 1));
}
.border-blue-25 {
  --tw-border-opacity: 1;
  border-color: rgb(245 250 255 / var(--tw-border-opacity, 1));
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(132 202 255 / var(--tw-border-opacity, 1));
}
.border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgb(83 177 253 / var(--tw-border-opacity, 1));
}
.border-blue-50 {
  --tw-border-opacity: 1;
  border-color: rgb(239 248 255 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(46 144 250 / var(--tw-border-opacity, 1));
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(21 112 239 / var(--tw-border-opacity, 1));
}
.border-blue-700 {
  --tw-border-opacity: 1;
  border-color: rgb(23 92 211 / var(--tw-border-opacity, 1));
}
.border-blue-800 {
  --tw-border-opacity: 1;
  border-color: rgb(24 73 169 / var(--tw-border-opacity, 1));
}
.border-blue-900 {
  --tw-border-opacity: 1;
  border-color: rgb(25 65 133 / var(--tw-border-opacity, 1));
}
.border-blue-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(234 236 245 / var(--tw-border-opacity, 1));
}
.border-blue-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(213 217 235 / var(--tw-border-opacity, 1));
}
.border-blue-gray-25 {
  --tw-border-opacity: 1;
  border-color: rgb(252 252 253 / var(--tw-border-opacity, 1));
}
.border-blue-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(175 181 217 / var(--tw-border-opacity, 1));
}
.border-blue-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(113 123 188 / var(--tw-border-opacity, 1));
}
.border-blue-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(248 249 252 / var(--tw-border-opacity, 1));
}
.border-blue-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(78 91 166 / var(--tw-border-opacity, 1));
}
.border-blue-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(62 71 132 / var(--tw-border-opacity, 1));
}
.border-blue-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(54 63 114 / var(--tw-border-opacity, 1));
}
.border-blue-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(41 48 86 / var(--tw-border-opacity, 1));
}
.border-blue-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(16 19 35 / var(--tw-border-opacity, 1));
}
.border-blue-light-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity, 1));
}
.border-blue-light-200 {
  --tw-border-opacity: 1;
  border-color: rgb(185 230 254 / var(--tw-border-opacity, 1));
}
.border-blue-light-25 {
  --tw-border-opacity: 1;
  border-color: rgb(245 251 255 / var(--tw-border-opacity, 1));
}
.border-blue-light-300 {
  --tw-border-opacity: 1;
  border-color: rgb(124 212 253 / var(--tw-border-opacity, 1));
}
.border-blue-light-400 {
  --tw-border-opacity: 1;
  border-color: rgb(54 191 250 / var(--tw-border-opacity, 1));
}
.border-blue-light-50 {
  --tw-border-opacity: 1;
  border-color: rgb(240 249 255 / var(--tw-border-opacity, 1));
}
.border-blue-light-500 {
  --tw-border-opacity: 1;
  border-color: rgb(11 165 236 / var(--tw-border-opacity, 1));
}
.border-blue-light-600 {
  --tw-border-opacity: 1;
  border-color: rgb(0 134 201 / var(--tw-border-opacity, 1));
}
.border-blue-light-700 {
  --tw-border-opacity: 1;
  border-color: rgb(2 106 162 / var(--tw-border-opacity, 1));
}
.border-blue-light-800 {
  --tw-border-opacity: 1;
  border-color: rgb(6 89 134 / var(--tw-border-opacity, 1));
}
.border-blue-light-900 {
  --tw-border-opacity: 1;
  border-color: rgb(11 74 111 / var(--tw-border-opacity, 1));
}
.border-brand-100 {
  --tw-border-opacity: 1;
  border-color: rgb(235 245 255 / var(--tw-border-opacity, 1));
}
.border-brand-200 {
  --tw-border-opacity: 1;
  border-color: rgb(215 234 254 / var(--tw-border-opacity, 1));
}
.border-brand-25 {
  --tw-border-opacity: 1;
  border-color: rgb(247 250 253 / var(--tw-border-opacity, 1));
}
.border-brand-300 {
  --tw-border-opacity: 1;
  border-color: rgb(187 219 251 / var(--tw-border-opacity, 1));
}
.border-brand-400 {
  --tw-border-opacity: 1;
  border-color: rgb(146 196 246 / var(--tw-border-opacity, 1));
}
.border-brand-50 {
  --tw-border-opacity: 1;
  border-color: rgb(241 247 253 / var(--tw-border-opacity, 1));
}
.border-brand-500 {
  --tw-border-opacity: 1;
  border-color: rgb(119 178 237 / var(--tw-border-opacity, 1));
}
.border-brand-600 {
  --tw-border-opacity: 1;
  border-color: rgb(86 151 217 / var(--tw-border-opacity, 1));
}
.border-brand-700 {
  --tw-border-opacity: 1;
  border-color: rgb(65 131 198 / var(--tw-border-opacity, 1));
}
.border-brand-800 {
  --tw-border-opacity: 1;
  border-color: rgb(56 107 158 / var(--tw-border-opacity, 1));
}
.border-brand-900 {
  --tw-border-opacity: 1;
  border-color: rgb(48 87 126 / var(--tw-border-opacity, 1));
}
.border-error-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 228 226 / var(--tw-border-opacity, 1));
}
.border-error-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 202 / var(--tw-border-opacity, 1));
}
.border-error-25 {
  --tw-border-opacity: 1;
  border-color: rgb(255 251 250 / var(--tw-border-opacity, 1));
}
.border-error-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 162 155 / var(--tw-border-opacity, 1));
}
.border-error-400 {
  --tw-border-opacity: 1;
  border-color: rgb(249 112 102 / var(--tw-border-opacity, 1));
}
.border-error-50 {
  --tw-border-opacity: 1;
  border-color: rgb(254 243 242 / var(--tw-border-opacity, 1));
}
.border-error-500 {
  --tw-border-opacity: 1;
  border-color: rgb(240 68 56 / var(--tw-border-opacity, 1));
}
.border-error-600 {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity, 1));
}
.border-error-700 {
  --tw-border-opacity: 1;
  border-color: rgb(180 35 24 / var(--tw-border-opacity, 1));
}
.border-error-800 {
  --tw-border-opacity: 1;
  border-color: rgb(145 32 24 / var(--tw-border-opacity, 1));
}
.border-error-900 {
  --tw-border-opacity: 1;
  border-color: rgb(122 39 26 / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}
.border-gray-25 {
  --tw-border-opacity: 1;
  border-color: rgb(253 253 253 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(164 167 174 / var(--tw-border-opacity, 1));
}
.border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity, 1));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(113 118 128 / var(--tw-border-opacity, 1));
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(83 88 98 / var(--tw-border-opacity, 1));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(65 70 81 / var(--tw-border-opacity, 1));
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(37 43 55 / var(--tw-border-opacity, 1));
}
.border-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(24 29 39 / var(--tw-border-opacity, 1));
}
.border-indigo-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 234 255 / var(--tw-border-opacity, 1));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 215 254 / var(--tw-border-opacity, 1));
}
.border-indigo-25 {
  --tw-border-opacity: 1;
  border-color: rgb(245 248 255 / var(--tw-border-opacity, 1));
}
.border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(164 188 253 / var(--tw-border-opacity, 1));
}
.border-indigo-400 {
  --tw-border-opacity: 1;
  border-color: rgb(128 152 249 / var(--tw-border-opacity, 1));
}
.border-indigo-50 {
  --tw-border-opacity: 1;
  border-color: rgb(238 244 255 / var(--tw-border-opacity, 1));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(97 114 243 / var(--tw-border-opacity, 1));
}
.border-indigo-600 {
  --tw-border-opacity: 1;
  border-color: rgb(68 76 231 / var(--tw-border-opacity, 1));
}
.border-indigo-700 {
  --tw-border-opacity: 1;
  border-color: rgb(53 56 205 / var(--tw-border-opacity, 1));
}
.border-indigo-800 {
  --tw-border-opacity: 1;
  border-color: rgb(45 49 166 / var(--tw-border-opacity, 1));
}
.border-indigo-900 {
  --tw-border-opacity: 1;
  border-color: rgb(45 50 130 / var(--tw-border-opacity, 1));
}
.border-purple-100 {
  --tw-border-opacity: 1;
  border-color: rgb(235 233 254 / var(--tw-border-opacity, 1));
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(217 214 254 / var(--tw-border-opacity, 1));
}
.border-purple-25 {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 255 / var(--tw-border-opacity, 1));
}
.border-purple-300 {
  --tw-border-opacity: 1;
  border-color: rgb(189 180 254 / var(--tw-border-opacity, 1));
}
.border-purple-400 {
  --tw-border-opacity: 1;
  border-color: rgb(155 138 251 / var(--tw-border-opacity, 1));
}
.border-purple-50 {
  --tw-border-opacity: 1;
  border-color: rgb(244 243 255 / var(--tw-border-opacity, 1));
}
.border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(122 90 248 / var(--tw-border-opacity, 1));
}
.border-purple-600 {
  --tw-border-opacity: 1;
  border-color: rgb(105 56 239 / var(--tw-border-opacity, 1));
}
.border-purple-700 {
  --tw-border-opacity: 1;
  border-color: rgb(89 37 220 / var(--tw-border-opacity, 1));
}
.border-purple-800 {
  --tw-border-opacity: 1;
  border-color: rgb(74 31 184 / var(--tw-border-opacity, 1));
}
.border-purple-900 {
  --tw-border-opacity: 1;
  border-color: rgb(62 28 150 / var(--tw-border-opacity, 1));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-success-100 {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 223 / var(--tw-border-opacity, 1));
}
.border-success-200 {
  --tw-border-opacity: 1;
  border-color: rgb(166 244 197 / var(--tw-border-opacity, 1));
}
.border-success-25 {
  --tw-border-opacity: 1;
  border-color: rgb(246 254 249 / var(--tw-border-opacity, 1));
}
.border-success-300 {
  --tw-border-opacity: 1;
  border-color: rgb(108 233 166 / var(--tw-border-opacity, 1));
}
.border-success-400 {
  --tw-border-opacity: 1;
  border-color: rgb(50 213 131 / var(--tw-border-opacity, 1));
}
.border-success-50 {
  --tw-border-opacity: 1;
  border-color: rgb(236 253 243 / var(--tw-border-opacity, 1));
}
.border-success-500 {
  --tw-border-opacity: 1;
  border-color: rgb(18 183 106 / var(--tw-border-opacity, 1));
}
.border-success-600 {
  --tw-border-opacity: 1;
  border-color: rgb(3 152 85 / var(--tw-border-opacity, 1));
}
.border-success-700 {
  --tw-border-opacity: 1;
  border-color: rgb(2 122 72 / var(--tw-border-opacity, 1));
}
.border-success-800 {
  --tw-border-opacity: 1;
  border-color: rgb(5 96 58 / var(--tw-border-opacity, 1));
}
.border-success-900 {
  --tw-border-opacity: 1;
  border-color: rgb(5 79 49 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-warning-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 199 / var(--tw-border-opacity, 1));
}
.border-warning-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 223 137 / var(--tw-border-opacity, 1));
}
.border-warning-25 {
  --tw-border-opacity: 1;
  border-color: rgb(255 252 245 / var(--tw-border-opacity, 1));
}
.border-warning-300 {
  --tw-border-opacity: 1;
  border-color: rgb(254 200 75 / var(--tw-border-opacity, 1));
}
.border-warning-400 {
  --tw-border-opacity: 1;
  border-color: rgb(253 176 34 / var(--tw-border-opacity, 1));
}
.border-warning-50 {
  --tw-border-opacity: 1;
  border-color: rgb(255 250 235 / var(--tw-border-opacity, 1));
}
.border-warning-500 {
  --tw-border-opacity: 1;
  border-color: rgb(247 144 9 / var(--tw-border-opacity, 1));
}
.border-warning-600 {
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity, 1));
}
.border-warning-700 {
  --tw-border-opacity: 1;
  border-color: rgb(181 71 8 / var(--tw-border-opacity, 1));
}
.border-warning-800 {
  --tw-border-opacity: 1;
  border-color: rgb(147 55 13 / var(--tw-border-opacity, 1));
}
.border-warning-900 {
  --tw-border-opacity: 1;
  border-color: rgb(122 46 14 / var(--tw-border-opacity, 1));
}
.border-b-blue-300 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(132 202 255 / var(--tw-border-opacity, 1));
}
.border-b-error-300 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(253 162 155 / var(--tw-border-opacity, 1));
}
.border-b-purple-300 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(189 180 254 / var(--tw-border-opacity, 1));
}
.border-b-success-300 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(108 233 166 / var(--tw-border-opacity, 1));
}
.border-b-warning-300 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(254 200 75 / var(--tw-border-opacity, 1));
}
.border-r-brand-500 {
  --tw-border-opacity: 1;
  border-right-color: rgb(119 178 237 / var(--tw-border-opacity, 1));
}
.border-r-brand-800 {
  --tw-border-opacity: 1;
  border-right-color: rgb(56 107 158 / var(--tw-border-opacity, 1));
}
.border-t-brand-300 {
  --tw-border-opacity: 1;
  border-top-color: rgb(187 219 251 / var(--tw-border-opacity, 1));
}
.\\!bg-brand-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(86 151 217 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-gray-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-\\[\\#bbdbfa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(187 219 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e7f3ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 243 255 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 233 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(178 221 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-25 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 250 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(132 202 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(83 177 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 248 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(46 144 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 112 239 / var(--tw-bg-opacity, 1));
}
.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(23 92 211 / var(--tw-bg-opacity, 1));
}
.bg-blue-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(24 73 169 / var(--tw-bg-opacity, 1));
}
.bg-blue-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(25 65 133 / var(--tw-bg-opacity, 1));
}
.bg-blue-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 236 245 / var(--tw-bg-opacity, 1));
}
.bg-blue-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(213 217 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-gray-25 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 252 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(175 181 217 / var(--tw-bg-opacity, 1));
}
.bg-blue-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(113 123 188 / var(--tw-bg-opacity, 1));
}
.bg-blue-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 252 / var(--tw-bg-opacity, 1));
}
.bg-blue-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(78 91 166 / var(--tw-bg-opacity, 1));
}
.bg-blue-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(62 71 132 / var(--tw-bg-opacity, 1));
}
.bg-blue-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(54 63 114 / var(--tw-bg-opacity, 1));
}
.bg-blue-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(41 48 86 / var(--tw-bg-opacity, 1));
}
.bg-blue-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 19 35 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(185 230 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-25 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 251 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(124 212 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(54 191 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(11 165 236 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 134 201 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 106 162 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 89 134 / var(--tw-bg-opacity, 1));
}
.bg-blue-light-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(11 74 111 / var(--tw-bg-opacity, 1));
}
.bg-brand-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(235 245 255 / var(--tw-bg-opacity, 1));
}
.bg-brand-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(215 234 254 / var(--tw-bg-opacity, 1));
}
.bg-brand-200\\/10 {
  background-color: rgb(215 234 254 / 0.1);
}
.bg-brand-200\\/20 {
  background-color: rgb(215 234 254 / 0.2);
}
.bg-brand-25 {
  --tw-bg-opacity: 1;
  background-color: rgb(247 250 253 / var(--tw-bg-opacity, 1));
}
.bg-brand-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 219 251 / var(--tw-bg-opacity, 1));
}
.bg-brand-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(146 196 246 / var(--tw-bg-opacity, 1));
}
.bg-brand-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 247 253 / var(--tw-bg-opacity, 1));
}
.bg-brand-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(119 178 237 / var(--tw-bg-opacity, 1));
}
.bg-brand-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(86 151 217 / var(--tw-bg-opacity, 1));
}
.bg-brand-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(65 131 198 / var(--tw-bg-opacity, 1));
}
.bg-brand-700\\/10 {
  background-color: rgb(65 131 198 / 0.1);
}
.bg-brand-700\\/50 {
  background-color: rgb(65 131 198 / 0.5);
}
.bg-brand-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(56 107 158 / var(--tw-bg-opacity, 1));
}
.bg-brand-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(48 87 126 / var(--tw-bg-opacity, 1));
}
.bg-error-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 228 226 / var(--tw-bg-opacity, 1));
}
.bg-error-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 202 / var(--tw-bg-opacity, 1));
}
.bg-error-25 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 250 / var(--tw-bg-opacity, 1));
}
.bg-error-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 162 155 / var(--tw-bg-opacity, 1));
}
.bg-error-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 112 102 / var(--tw-bg-opacity, 1));
}
.bg-error-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}
.bg-error-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}
.bg-error-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity, 1));
}
.bg-error-600\\/10 {
  background-color: rgb(217 45 32 / 0.1);
}
.bg-error-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(180 35 24 / var(--tw-bg-opacity, 1));
}
.bg-error-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(145 32 24 / var(--tw-bg-opacity, 1));
}
.bg-error-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(122 39 26 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-25 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(213 215 218 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(164 167 174 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(113 118 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(83 88 98 / var(--tw-bg-opacity, 1));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(65 70 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 43 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-800\\/50 {
  background-color: rgb(37 43 55 / 0.5);
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(24 29 39 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 234 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(199 215 254 / var(--tw-bg-opacity, 1));
}
.bg-indigo-25 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 248 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(164 188 253 / var(--tw-bg-opacity, 1));
}
.bg-indigo-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(128 152 249 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 244 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(97 114 243 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(68 76 231 / var(--tw-bg-opacity, 1));
}
.bg-indigo-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(53 56 205 / var(--tw-bg-opacity, 1));
}
.bg-indigo-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(45 49 166 / var(--tw-bg-opacity, 1));
}
.bg-indigo-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(45 50 130 / var(--tw-bg-opacity, 1));
}
.bg-light {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 246 237 / var(--tw-bg-opacity, 1));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(235 233 254 / var(--tw-bg-opacity, 1));
}
.bg-purple-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 214 254 / var(--tw-bg-opacity, 1));
}
.bg-purple-25 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(189 180 254 / var(--tw-bg-opacity, 1));
}
.bg-purple-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(155 138 251 / var(--tw-bg-opacity, 1));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 243 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(122 90 248 / var(--tw-bg-opacity, 1));
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(105 56 239 / var(--tw-bg-opacity, 1));
}
.bg-purple-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(89 37 220 / var(--tw-bg-opacity, 1));
}
.bg-purple-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 31 184 / var(--tw-bg-opacity, 1));
}
.bg-purple-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(62 28 150 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-success-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 223 / var(--tw-bg-opacity, 1));
}
.bg-success-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(166 244 197 / var(--tw-bg-opacity, 1));
}
.bg-success-25 {
  --tw-bg-opacity: 1;
  background-color: rgb(246 254 249 / var(--tw-bg-opacity, 1));
}
.bg-success-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(108 233 166 / var(--tw-bg-opacity, 1));
}
.bg-success-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(50 213 131 / var(--tw-bg-opacity, 1));
}
.bg-success-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 243 / var(--tw-bg-opacity, 1));
}
.bg-success-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(18 183 106 / var(--tw-bg-opacity, 1));
}
.bg-success-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity, 1));
}
.bg-success-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 122 72 / var(--tw-bg-opacity, 1));
}
.bg-success-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 96 58 / var(--tw-bg-opacity, 1));
}
.bg-success-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 79 49 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-warning-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 199 / var(--tw-bg-opacity, 1));
}
.bg-warning-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 223 137 / var(--tw-bg-opacity, 1));
}
.bg-warning-25 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 252 245 / var(--tw-bg-opacity, 1));
}
.bg-warning-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 200 75 / var(--tw-bg-opacity, 1));
}
.bg-warning-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 176 34 / var(--tw-bg-opacity, 1));
}
.bg-warning-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1));
}
.bg-warning-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(247 144 9 / var(--tw-bg-opacity, 1));
}
.bg-warning-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity, 1));
}
.bg-warning-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(181 71 8 / var(--tw-bg-opacity, 1));
}
.bg-warning-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 55 13 / var(--tw-bg-opacity, 1));
}
.bg-warning-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(122 46 14 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-brand-200 {
  --tw-gradient-from: #D7EAFE var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(215 234 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-200 {
  --tw-gradient-from: #d9d6fe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 214 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-success-200 {
  --tw-gradient-from: #a6f4c5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(166 244 197 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-brand-100 {
  --tw-gradient-to: #EBF5FF var(--tw-gradient-to-position);
}
.to-purple-100 {
  --tw-gradient-to: #ebe9fe var(--tw-gradient-to-position);
}
.to-success-100 {
  --tw-gradient-to: #d1fadf var(--tw-gradient-to-position);
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.\\!p-0 {
  padding: 0px !important;
}
.\\!p-2 {
  padding: 0.5rem !important;
}
.\\!p-4 {
  padding: 1rem !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[12px\\] {
  padding: 12px;
}
.p-\\[14px\\] {
  padding: 14px;
}
.p-\\[20px\\] {
  padding: 20px;
}
.p-\\[6px\\] {
  padding: 6px;
}
.\\!px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.\\!py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.\\!py-2\\.5 {
  padding-top: 0.625rem !important;
  padding-bottom: 0.625rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[2px\\] {
  padding-left: 2px;
  padding-right: 2px;
}
.px-\\[9px\\] {
  padding-left: 9px;
  padding-right: 9px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[12px\\] {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[13px\\] {
  padding-top: 13px;
  padding-bottom: 13px;
}
.py-\\[14px\\] {
  padding-top: 14px;
  padding-bottom: 14px;
}
.py-\\[19px\\] {
  padding-top: 19px;
  padding-bottom: 19px;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.\\!ps-10 {
  padding-inline-start: 2.5rem !important;
}
.\\!ps-20 {
  padding-inline-start: 5rem !important;
}
.\\!pt-0 {
  padding-top: 0px !important;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-16 {
  padding-left: 4rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-20 {
  padding-left: 5rem;
}
.pl-24 {
  padding-left: 6rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.ps-8 {
  padding-inline-start: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-7 {
  padding-top: 1.75rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.\\!text-center {
  text-align: center !important;
}
.text-center {
  text-align: center;
}
.\\!text-right {
  text-align: right !important;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.font-inter {
  font-family: 'Inter', sans-serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-h5 {
  font-size: 1.125rem;
  line-height: 1.4;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-sm\\/5 {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.font-thin {
  font-weight: 100;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-3 {
  line-height: .75rem;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.leading-\\[30px\\] {
  line-height: 30px;
}
.leading-\\[32px\\] {
  line-height: 32px;
}
.leading-none {
  line-height: 1;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.\\!text-gray-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(164 167 174 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-light {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-100 {
  --tw-text-opacity: 1;
  color: rgb(209 233 255 / var(--tw-text-opacity, 1));
}
.text-blue-200 {
  --tw-text-opacity: 1;
  color: rgb(178 221 255 / var(--tw-text-opacity, 1));
}
.text-blue-25 {
  --tw-text-opacity: 1;
  color: rgb(245 250 255 / var(--tw-text-opacity, 1));
}
.text-blue-300 {
  --tw-text-opacity: 1;
  color: rgb(132 202 255 / var(--tw-text-opacity, 1));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(83 177 253 / var(--tw-text-opacity, 1));
}
.text-blue-50 {
  --tw-text-opacity: 1;
  color: rgb(239 248 255 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(46 144 250 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(21 112 239 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(23 92 211 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(24 73 169 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(25 65 133 / var(--tw-text-opacity, 1));
}
.text-blue-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(234 236 245 / var(--tw-text-opacity, 1));
}
.text-blue-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(213 217 235 / var(--tw-text-opacity, 1));
}
.text-blue-gray-25 {
  --tw-text-opacity: 1;
  color: rgb(252 252 253 / var(--tw-text-opacity, 1));
}
.text-blue-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(175 181 217 / var(--tw-text-opacity, 1));
}
.text-blue-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(113 123 188 / var(--tw-text-opacity, 1));
}
.text-blue-gray-50 {
  --tw-text-opacity: 1;
  color: rgb(248 249 252 / var(--tw-text-opacity, 1));
}
.text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(78 91 166 / var(--tw-text-opacity, 1));
}
.text-blue-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(62 71 132 / var(--tw-text-opacity, 1));
}
.text-blue-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(54 63 114 / var(--tw-text-opacity, 1));
}
.text-blue-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(41 48 86 / var(--tw-text-opacity, 1));
}
.text-blue-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(16 19 35 / var(--tw-text-opacity, 1));
}
.text-blue-light-100 {
  --tw-text-opacity: 1;
  color: rgb(224 242 254 / var(--tw-text-opacity, 1));
}
.text-blue-light-200 {
  --tw-text-opacity: 1;
  color: rgb(185 230 254 / var(--tw-text-opacity, 1));
}
.text-blue-light-25 {
  --tw-text-opacity: 1;
  color: rgb(245 251 255 / var(--tw-text-opacity, 1));
}
.text-blue-light-300 {
  --tw-text-opacity: 1;
  color: rgb(124 212 253 / var(--tw-text-opacity, 1));
}
.text-blue-light-400 {
  --tw-text-opacity: 1;
  color: rgb(54 191 250 / var(--tw-text-opacity, 1));
}
.text-blue-light-50 {
  --tw-text-opacity: 1;
  color: rgb(240 249 255 / var(--tw-text-opacity, 1));
}
.text-blue-light-500 {
  --tw-text-opacity: 1;
  color: rgb(11 165 236 / var(--tw-text-opacity, 1));
}
.text-blue-light-600 {
  --tw-text-opacity: 1;
  color: rgb(0 134 201 / var(--tw-text-opacity, 1));
}
.text-blue-light-700 {
  --tw-text-opacity: 1;
  color: rgb(2 106 162 / var(--tw-text-opacity, 1));
}
.text-blue-light-800 {
  --tw-text-opacity: 1;
  color: rgb(6 89 134 / var(--tw-text-opacity, 1));
}
.text-blue-light-900 {
  --tw-text-opacity: 1;
  color: rgb(11 74 111 / var(--tw-text-opacity, 1));
}
.text-brand-100 {
  --tw-text-opacity: 1;
  color: rgb(235 245 255 / var(--tw-text-opacity, 1));
}
.text-brand-200 {
  --tw-text-opacity: 1;
  color: rgb(215 234 254 / var(--tw-text-opacity, 1));
}
.text-brand-25 {
  --tw-text-opacity: 1;
  color: rgb(247 250 253 / var(--tw-text-opacity, 1));
}
.text-brand-300 {
  --tw-text-opacity: 1;
  color: rgb(187 219 251 / var(--tw-text-opacity, 1));
}
.text-brand-400 {
  --tw-text-opacity: 1;
  color: rgb(146 196 246 / var(--tw-text-opacity, 1));
}
.text-brand-50 {
  --tw-text-opacity: 1;
  color: rgb(241 247 253 / var(--tw-text-opacity, 1));
}
.text-brand-500 {
  --tw-text-opacity: 1;
  color: rgb(119 178 237 / var(--tw-text-opacity, 1));
}
.text-brand-600 {
  --tw-text-opacity: 1;
  color: rgb(86 151 217 / var(--tw-text-opacity, 1));
}
.text-brand-700 {
  --tw-text-opacity: 1;
  color: rgb(65 131 198 / var(--tw-text-opacity, 1));
}
.text-brand-800 {
  --tw-text-opacity: 1;
  color: rgb(56 107 158 / var(--tw-text-opacity, 1));
}
.text-brand-900 {
  --tw-text-opacity: 1;
  color: rgb(48 87 126 / var(--tw-text-opacity, 1));
}
.text-error-100 {
  --tw-text-opacity: 1;
  color: rgb(254 228 226 / var(--tw-text-opacity, 1));
}
.text-error-200 {
  --tw-text-opacity: 1;
  color: rgb(254 205 202 / var(--tw-text-opacity, 1));
}
.text-error-25 {
  --tw-text-opacity: 1;
  color: rgb(255 251 250 / var(--tw-text-opacity, 1));
}
.text-error-300 {
  --tw-text-opacity: 1;
  color: rgb(253 162 155 / var(--tw-text-opacity, 1));
}
.text-error-400 {
  --tw-text-opacity: 1;
  color: rgb(249 112 102 / var(--tw-text-opacity, 1));
}
.text-error-50 {
  --tw-text-opacity: 1;
  color: rgb(254 243 242 / var(--tw-text-opacity, 1));
}
.text-error-500 {
  --tw-text-opacity: 1;
  color: rgb(240 68 56 / var(--tw-text-opacity, 1));
}
.text-error-600 {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity, 1));
}
.text-error-700 {
  --tw-text-opacity: 1;
  color: rgb(180 35 24 / var(--tw-text-opacity, 1));
}
.text-error-800 {
  --tw-text-opacity: 1;
  color: rgb(145 32 24 / var(--tw-text-opacity, 1));
}
.text-error-900 {
  --tw-text-opacity: 1;
  color: rgb(122 39 26 / var(--tw-text-opacity, 1));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(233 234 235 / var(--tw-text-opacity, 1));
}
.text-gray-25 {
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(213 215 218 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(164 167 174 / var(--tw-text-opacity, 1));
}
.text-gray-50 {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(83 88 98 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(24 29 39 / var(--tw-text-opacity, 1));
}
.text-gray-950 {
  --tw-text-opacity: 1;
  color: rgb(86 89 93 / var(--tw-text-opacity, 1));
}
.text-indigo-100 {
  --tw-text-opacity: 1;
  color: rgb(224 234 255 / var(--tw-text-opacity, 1));
}
.text-indigo-200 {
  --tw-text-opacity: 1;
  color: rgb(199 215 254 / var(--tw-text-opacity, 1));
}
.text-indigo-25 {
  --tw-text-opacity: 1;
  color: rgb(245 248 255 / var(--tw-text-opacity, 1));
}
.text-indigo-300 {
  --tw-text-opacity: 1;
  color: rgb(164 188 253 / var(--tw-text-opacity, 1));
}
.text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(128 152 249 / var(--tw-text-opacity, 1));
}
.text-indigo-50 {
  --tw-text-opacity: 1;
  color: rgb(238 244 255 / var(--tw-text-opacity, 1));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(97 114 243 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(68 76 231 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(53 56 205 / var(--tw-text-opacity, 1));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(45 49 166 / var(--tw-text-opacity, 1));
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(45 50 130 / var(--tw-text-opacity, 1));
}
.text-light {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(196 50 10 / var(--tw-text-opacity, 1));
}
.text-purple-100 {
  --tw-text-opacity: 1;
  color: rgb(235 233 254 / var(--tw-text-opacity, 1));
}
.text-purple-200 {
  --tw-text-opacity: 1;
  color: rgb(217 214 254 / var(--tw-text-opacity, 1));
}
.text-purple-25 {
  --tw-text-opacity: 1;
  color: rgb(250 250 255 / var(--tw-text-opacity, 1));
}
.text-purple-300 {
  --tw-text-opacity: 1;
  color: rgb(189 180 254 / var(--tw-text-opacity, 1));
}
.text-purple-400 {
  --tw-text-opacity: 1;
  color: rgb(155 138 251 / var(--tw-text-opacity, 1));
}
.text-purple-50 {
  --tw-text-opacity: 1;
  color: rgb(244 243 255 / var(--tw-text-opacity, 1));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(122 90 248 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(105 56 239 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(89 37 220 / var(--tw-text-opacity, 1));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(74 31 184 / var(--tw-text-opacity, 1));
}
.text-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(62 28 150 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-success-100 {
  --tw-text-opacity: 1;
  color: rgb(209 250 223 / var(--tw-text-opacity, 1));
}
.text-success-200 {
  --tw-text-opacity: 1;
  color: rgb(166 244 197 / var(--tw-text-opacity, 1));
}
.text-success-25 {
  --tw-text-opacity: 1;
  color: rgb(246 254 249 / var(--tw-text-opacity, 1));
}
.text-success-300 {
  --tw-text-opacity: 1;
  color: rgb(108 233 166 / var(--tw-text-opacity, 1));
}
.text-success-400 {
  --tw-text-opacity: 1;
  color: rgb(50 213 131 / var(--tw-text-opacity, 1));
}
.text-success-50 {
  --tw-text-opacity: 1;
  color: rgb(236 253 243 / var(--tw-text-opacity, 1));
}
.text-success-500 {
  --tw-text-opacity: 1;
  color: rgb(18 183 106 / var(--tw-text-opacity, 1));
}
.text-success-600 {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity, 1));
}
.text-success-700 {
  --tw-text-opacity: 1;
  color: rgb(2 122 72 / var(--tw-text-opacity, 1));
}
.text-success-800 {
  --tw-text-opacity: 1;
  color: rgb(5 96 58 / var(--tw-text-opacity, 1));
}
.text-success-900 {
  --tw-text-opacity: 1;
  color: rgb(5 79 49 / var(--tw-text-opacity, 1));
}
.text-warning-100 {
  --tw-text-opacity: 1;
  color: rgb(254 240 199 / var(--tw-text-opacity, 1));
}
.text-warning-200 {
  --tw-text-opacity: 1;
  color: rgb(254 223 137 / var(--tw-text-opacity, 1));
}
.text-warning-25 {
  --tw-text-opacity: 1;
  color: rgb(255 252 245 / var(--tw-text-opacity, 1));
}
.text-warning-300 {
  --tw-text-opacity: 1;
  color: rgb(254 200 75 / var(--tw-text-opacity, 1));
}
.text-warning-400 {
  --tw-text-opacity: 1;
  color: rgb(253 176 34 / var(--tw-text-opacity, 1));
}
.text-warning-50 {
  --tw-text-opacity: 1;
  color: rgb(255 250 235 / var(--tw-text-opacity, 1));
}
.text-warning-500 {
  --tw-text-opacity: 1;
  color: rgb(247 144 9 / var(--tw-text-opacity, 1));
}
.text-warning-600 {
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity, 1));
}
.text-warning-700 {
  --tw-text-opacity: 1;
  color: rgb(181 71 8 / var(--tw-text-opacity, 1));
}
.text-warning-800 {
  --tw-text-opacity: 1;
  color: rgb(147 55 13 / var(--tw-text-opacity, 1));
}
.text-warning-900 {
  --tw-text-opacity: 1;
  color: rgb(122 46 14 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/50 {
  color: rgb(255 255 255 / 0.5);
}
.underline {
  text-decoration-line: underline;
}
.decoration-1 {
  text-decoration-thickness: 1px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(164 167 174 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(113 118 128 / var(--tw-placeholder-opacity, 1));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-70 {
  opacity: 0.7;
}
.shadow-\\[0px_10px_10px_-5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\] {
  --tw-shadow: 0px 10px 10px -5px rgba(0,0,0,0.2);
  --tw-shadow-colored: 0px 10px 10px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[2px_2px_2px_2px_\\#d92d20\\] {
  --tw-shadow: 2px 2px 2px 2px #d92d20;
  --tw-shadow-colored: 2px 2px 2px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-box {
  --tw-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.12);
  --tw-shadow-colored: 0px 12px 24px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card {
  --tw-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.1);
  --tw-shadow-colored: 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline-0 {
  outline-width: 0px;
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-brand-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(119 178 237 / var(--tw-ring-opacity, 1));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_4px_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-drop-shadow: drop-shadow(0 4px 10px rgba(0,0,0,0.3));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.scrollbar-w-medium::-webkit-scrollbar {
  width: 10px;
}
.scrollbar-w-medium::-webkit-scrollbar-horizontal {
  height: 10px;
}
.scrollbar-track-transparent::-webkit-scrollbar-track {
  background-color: transparent;
}
.scrollbar-thumb-brand::-webkit-scrollbar-thumb {
  background-color: #4183C6;
  border-radius: 0.375rem;
}
.scrollbar-thumb-brand::-webkit-scrollbar-thumb:hover {
  background-color: #5697D9;
}
.\\[appearance\\:textfield\\] {
  appearance: textfield;
}
.\\[moz-appearance\\:textfield\\] {
  moz-appearance: textfield;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.input {
  display: block;
  width: 100%;
}

input[type=checkbox]:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
}

input[type=radio] {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 14px auto;
}
input[type=radio].check-sm {
  background-size: 10px auto;
}

input[type=radio]:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center;
  background-repeat: no-repeat;
}

.icon-input {
  position: absolute;
  top: 50%;
  height: 2rem;
  width: 2.5rem;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

@media (min-width: 768px) {

  .icon-input {
    height: 2.5rem;
    width: 3rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
.icon-input.icon-start {
  inset-inline-start: 0px;
  border-inline-end-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}
.icon-input.icon-end {
  inset-inline-end: 0px;
}

.active-select .custom-select__control {
  border-color: #d92d20 !important;
}

.custom-select-container .custom-select__control {
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  box-shadow: none;
}
.custom-select-container .custom-select__control:hover {
  --tw-border-opacity: 1;
  border-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
}
.custom-select-container .custom-select__control.custom-select__control--is-focused {
  --tw-border-opacity: 1;
  border-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
}
.custom-select-container .custom-select__control.custom-select__control--menu-is-open {
  --tw-border-opacity: 1;
  border-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.12);
  --tw-shadow-colored: 0px 12px 24px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.custom-select-container .custom-select__control.custom-select__control--menu-is-open .custom-select__single-value {
  --tw-text-opacity: 1;
  color: rgb(24 29 39 / var(--tw-text-opacity, 1));
}
.custom-select-container .custom-select__value-container {
  min-height: 2.75rem;
  border-radius: 0.5rem;
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.custom-select-container .custom-select__placeholder {
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}
.custom-select-container .custom-select__menu {
  z-index: 10;
  margin: 0px;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
  --tw-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.12);
  --tw-shadow-colored: 0px 12px 24px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.custom-select-container .custom-select__menu .custom-select__option {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
}

/* Theming for CustomSelect */
.custom-select-container.theme-blue .custom-select__control,
.custom-select-container.theme-blue .custom-select__control.custom-select__control--is-focused,
.custom-select-container.theme-blue .custom-select__control.custom-select__control--menu-is-open {
  background-color: #5697d9 !important;
  border-color: #5697d9 !important;
}
.custom-select-container.theme-blue .custom-select__single-value,
.custom-select-container.theme-blue .custom-select__placeholder,
.custom-select-container.theme-blue .custom-select__indicators,
.custom-select-container.theme-blue .custom-select__indicator {
  color: #ffffff !important;
  font-weight: 600;
}

.custom-select-container.theme-red .custom-select__control,
.custom-select-container.theme-red .custom-select__control.custom-select__control--is-focused,
.custom-select-container.theme-red .custom-select__control.custom-select__control--menu-is-open {
  background-color: #fee2e2 !important;
  border-color: #fecaca !important;
}
.custom-select-container.theme-red .custom-select__single-value,
.custom-select-container.theme-red .custom-select__placeholder,
.custom-select-container.theme-red .custom-select__indicators,
.custom-select-container.theme-red .custom-select__indicator {
  color: #b91c1c !important;
  font-weight: 600;
}

.custom-select-container.theme-yellow .custom-select__control,
.custom-select-container.theme-yellow .custom-select__control.custom-select__control--is-focused,
.custom-select-container.theme-yellow .custom-select__control.custom-select__control--menu-is-open {
  background-color: #fef0c7 !important;
  border-color: #fedf89 !important;
}
.custom-select-container.theme-yellow .custom-select__single-value,
.custom-select-container.theme-yellow .custom-select__placeholder,
.custom-select-container.theme-yellow .custom-select__indicators,
.custom-select-container.theme-yellow .custom-select__indicator {
  color: #b54708 !important;
  font-weight: 600;
}

.custom-select-container.theme-green .custom-select__control,
.custom-select-container.theme-green .custom-select__control.custom-select__control--is-focused,
.custom-select-container.theme-green .custom-select__control.custom-select__control--menu-is-open {
  background-color: #d1fadf !important;
  border-color: #a6f4c5 !important;
}
.custom-select-container.theme-green .custom-select__single-value,
.custom-select-container.theme-green .custom-select__placeholder,
.custom-select-container.theme-green .custom-select__indicators,
.custom-select-container.theme-green .custom-select__indicator {
  color: #027a48 !important;
  font-weight: 600;
}

/* Apply styles to the span representing the radio button */
input[type=radio] + label .radio-span {
  transition: background 0.2s, transform 0.2s;
}

input[type=radio]:checked + label .radio-span {
  background-color: #5697d9 !important;
  box-shadow: 0px 0px 0px 4px #f1f7fd inset;
}

input[type=radio]:checked + label .radio-span span {
  background-color: #5697d9 !important; /* bg-blue when checked */
}

input[type=radio]:checked + label {
  color: #5697d9 !important; /* text-blue */
}

.table-common thead th {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(187 219 250 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

@media (min-width: 992px) {

  .table-common thead th {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

.table-common tbody tr:nth-child(even) {
  background: #f6fbff;
}

.table-common tbody tr td {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}

.table-common tbody tr td:first-child {
  border-left-width: 0px;
}

.table-common tbody tr td:last-child {
  border-right-width: 0px;
}

.table-common tbody tr:first-child td {
  border-top-width: 0px;
}

.table-common tbody tr:last-child td {
  border-bottom-width: 0px;
}

.manpower-select .custom-select__value-container {
  min-height: 35px;
}
.manpower-select .custom-select__menu {
  z-index: 4 !important;
}
.placeholder\\:text-sm::placeholder {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.placeholder\\:text-xs::placeholder {
  font-size: 0.75rem;
  line-height: 1rem;
}
.first\\:\\!w-\\[20px\\]:first-child {
  width: 20px !important;
}
.first\\:rounded-l-xl:first-child {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.first\\:border-l:first-child {
  border-left-width: 1px;
}
.first\\:text-center:first-child {
  text-align: center;
}
.last\\:mb-0:last-child {
  margin-bottom: 0px;
}
.last\\:me-0:last-child {
  margin-inline-end: 0px;
}
.last\\:rounded-r-xl:last-child {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.last\\:border-r:last-child {
  border-right-width: 1px;
}
.odd\\:bg-white:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.even\\:bg-gray-50:nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.checked\\:border-brand-600:checked {
  --tw-border-opacity: 1;
  border-color: rgb(86 151 217 / var(--tw-border-opacity, 1));
}
.checked\\:bg-brand-300:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(187 219 251 / var(--tw-bg-opacity, 1));
}
.checked\\:text-red-600:checked {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.focus-within\\:border-gray-300:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
}
.hover\\:border-brand-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(215 234 254 / var(--tw-border-opacity, 1));
}
.hover\\:border-brand-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(187 219 251 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(164 167 174 / var(--tw-border-opacity, 1));
}
.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 233 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(178 221 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-25:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 250 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(132 202 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(83 177 253 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 248 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(46 144 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 112 239 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(23 92 211 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(24 73 169 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(25 65 133 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 236 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(213 217 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-gray-25:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(252 252 253 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(175 181 217 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-gray-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(113 123 188 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(78 91 166 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(62 71 132 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(54 63 114 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(41 48 86 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-gray-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(16 19 35 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-light-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-light-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 230 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-light-25:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 251 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-light-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(124 212 253 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-light-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(54 191 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-light-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-light-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(11 165 236 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-light-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 134 201 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-light-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(2 106 162 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-light-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(6 89 134 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-light-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(11 74 111 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(235 245 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(215 234 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-25:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(247 250 253 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(187 219 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(146 196 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 247 253 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(119 178 237 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(86 151 217 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(65 131 198 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(56 107 158 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(48 87 126 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-error-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 228 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-error-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-error-25:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-error-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 162 155 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-error-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 112 102 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-error-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-error-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-error-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-error-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(180 35 24 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-error-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(145 32 24 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-error-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(122 39 26 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-25:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(213 215 218 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(164 167 174 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50\\/50:hover {
  background-color: rgb(250 250 250 / 0.5);
}
.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(113 118 128 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(83 88 98 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(65 70 81 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 43 55 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(24 29 39 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 234 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(199 215 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-25:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 248 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(164 188 253 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(128 152 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 244 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(97 114 243 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(68 76 231 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(53 56 205 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(45 49 166 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(45 50 130 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(235 233 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 214 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-25:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(189 180 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(155 138 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 243 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(122 90 248 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(105 56 239 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(89 37 220 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(74 31 184 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(62 28 150 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 223 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(166 244 197 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-25:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 254 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(108 233 166 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(50 213 131 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 243 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(18 183 106 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(2 122 72 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 96 58 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-success-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 79 49 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 199 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 223 137 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-25:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 252 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 200 75 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 176 34 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(247 144 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(181 71 8 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(147 55 13 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(122 46 14 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-opacity-70:hover {
  --tw-bg-opacity: 0.7;
}
.hover\\:text-blue-100:hover {
  --tw-text-opacity: 1;
  color: rgb(209 233 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-200:hover {
  --tw-text-opacity: 1;
  color: rgb(178 221 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-25:hover {
  --tw-text-opacity: 1;
  color: rgb(245 250 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-300:hover {
  --tw-text-opacity: 1;
  color: rgb(132 202 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-400:hover {
  --tw-text-opacity: 1;
  color: rgb(83 177 253 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-50:hover {
  --tw-text-opacity: 1;
  color: rgb(239 248 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(46 144 250 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(21 112 239 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(23 92 211 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(24 73 169 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-900:hover {
  --tw-text-opacity: 1;
  color: rgb(25 65 133 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-gray-100:hover {
  --tw-text-opacity: 1;
  color: rgb(234 236 245 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-gray-200:hover {
  --tw-text-opacity: 1;
  color: rgb(213 217 235 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-gray-25:hover {
  --tw-text-opacity: 1;
  color: rgb(252 252 253 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-gray-300:hover {
  --tw-text-opacity: 1;
  color: rgb(175 181 217 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-gray-400:hover {
  --tw-text-opacity: 1;
  color: rgb(113 123 188 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-gray-50:hover {
  --tw-text-opacity: 1;
  color: rgb(248 249 252 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(78 91 166 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(62 71 132 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(54 63 114 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(41 48 86 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(16 19 35 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-light-100:hover {
  --tw-text-opacity: 1;
  color: rgb(224 242 254 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-light-200:hover {
  --tw-text-opacity: 1;
  color: rgb(185 230 254 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-light-25:hover {
  --tw-text-opacity: 1;
  color: rgb(245 251 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-light-300:hover {
  --tw-text-opacity: 1;
  color: rgb(124 212 253 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-light-400:hover {
  --tw-text-opacity: 1;
  color: rgb(54 191 250 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-light-50:hover {
  --tw-text-opacity: 1;
  color: rgb(240 249 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-light-500:hover {
  --tw-text-opacity: 1;
  color: rgb(11 165 236 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-light-600:hover {
  --tw-text-opacity: 1;
  color: rgb(0 134 201 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-light-700:hover {
  --tw-text-opacity: 1;
  color: rgb(2 106 162 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-light-800:hover {
  --tw-text-opacity: 1;
  color: rgb(6 89 134 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-light-900:hover {
  --tw-text-opacity: 1;
  color: rgb(11 74 111 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-100:hover {
  --tw-text-opacity: 1;
  color: rgb(235 245 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-200:hover {
  --tw-text-opacity: 1;
  color: rgb(215 234 254 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-25:hover {
  --tw-text-opacity: 1;
  color: rgb(247 250 253 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-300:hover {
  --tw-text-opacity: 1;
  color: rgb(187 219 251 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-400:hover {
  --tw-text-opacity: 1;
  color: rgb(146 196 246 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-50:hover {
  --tw-text-opacity: 1;
  color: rgb(241 247 253 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-500:hover {
  --tw-text-opacity: 1;
  color: rgb(119 178 237 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-600:hover {
  --tw-text-opacity: 1;
  color: rgb(86 151 217 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-700:hover {
  --tw-text-opacity: 1;
  color: rgb(65 131 198 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-800:hover {
  --tw-text-opacity: 1;
  color: rgb(56 107 158 / var(--tw-text-opacity, 1));
}
.hover\\:text-brand-900:hover {
  --tw-text-opacity: 1;
  color: rgb(48 87 126 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-100:hover {
  --tw-text-opacity: 1;
  color: rgb(254 228 226 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-200:hover {
  --tw-text-opacity: 1;
  color: rgb(254 205 202 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-25:hover {
  --tw-text-opacity: 1;
  color: rgb(255 251 250 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-300:hover {
  --tw-text-opacity: 1;
  color: rgb(253 162 155 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-400:hover {
  --tw-text-opacity: 1;
  color: rgb(249 112 102 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-50:hover {
  --tw-text-opacity: 1;
  color: rgb(254 243 242 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-500:hover {
  --tw-text-opacity: 1;
  color: rgb(240 68 56 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-600:hover {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-700:hover {
  --tw-text-opacity: 1;
  color: rgb(180 35 24 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-800:hover {
  --tw-text-opacity: 1;
  color: rgb(145 32 24 / var(--tw-text-opacity, 1));
}
.hover\\:text-error-900:hover {
  --tw-text-opacity: 1;
  color: rgb(122 39 26 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-100:hover {
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-200:hover {
  --tw-text-opacity: 1;
  color: rgb(233 234 235 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-25:hover {
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-300:hover {
  --tw-text-opacity: 1;
  color: rgb(213 215 218 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-400:hover {
  --tw-text-opacity: 1;
  color: rgb(164 167 174 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-50:hover {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(83 88 98 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(24 29 39 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-100:hover {
  --tw-text-opacity: 1;
  color: rgb(224 234 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-200:hover {
  --tw-text-opacity: 1;
  color: rgb(199 215 254 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-25:hover {
  --tw-text-opacity: 1;
  color: rgb(245 248 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-300:hover {
  --tw-text-opacity: 1;
  color: rgb(164 188 253 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-400:hover {
  --tw-text-opacity: 1;
  color: rgb(128 152 249 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-50:hover {
  --tw-text-opacity: 1;
  color: rgb(238 244 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-500:hover {
  --tw-text-opacity: 1;
  color: rgb(97 114 243 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-600:hover {
  --tw-text-opacity: 1;
  color: rgb(68 76 231 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-700:hover {
  --tw-text-opacity: 1;
  color: rgb(53 56 205 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-800:hover {
  --tw-text-opacity: 1;
  color: rgb(45 49 166 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-900:hover {
  --tw-text-opacity: 1;
  color: rgb(45 50 130 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-100:hover {
  --tw-text-opacity: 1;
  color: rgb(235 233 254 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-200:hover {
  --tw-text-opacity: 1;
  color: rgb(217 214 254 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-25:hover {
  --tw-text-opacity: 1;
  color: rgb(250 250 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-300:hover {
  --tw-text-opacity: 1;
  color: rgb(189 180 254 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-400:hover {
  --tw-text-opacity: 1;
  color: rgb(155 138 251 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-50:hover {
  --tw-text-opacity: 1;
  color: rgb(244 243 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-500:hover {
  --tw-text-opacity: 1;
  color: rgb(122 90 248 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-600:hover {
  --tw-text-opacity: 1;
  color: rgb(105 56 239 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-700:hover {
  --tw-text-opacity: 1;
  color: rgb(89 37 220 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-800:hover {
  --tw-text-opacity: 1;
  color: rgb(74 31 184 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-900:hover {
  --tw-text-opacity: 1;
  color: rgb(62 28 150 / var(--tw-text-opacity, 1));
}
.hover\\:text-success-100:hover {
  --tw-text-opacity: 1;
  color: rgb(209 250 223 / var(--tw-text-opacity, 1));
}
.hover\\:text-success-200:hover {
  --tw-text-opacity: 1;
  color: rgb(166 244 197 / var(--tw-text-opacity, 1));
}
.hover\\:text-success-25:hover {
  --tw-text-opacity: 1;
  color: rgb(246 254 249 / var(--tw-text-opacity, 1));
}
.hover\\:text-success-300:hover {
  --tw-text-opacity: 1;
  color: rgb(108 233 166 / var(--tw-text-opacity, 1));
}
.hover\\:text-success-400:hover {
  --tw-text-opacity: 1;
  color: rgb(50 213 131 / var(--tw-text-opacity, 1));
}
.hover\\:text-success-50:hover {
  --tw-text-opacity: 1;
  color: rgb(236 253 243 / var(--tw-text-opacity, 1));
}
.hover\\:text-success-500:hover {
  --tw-text-opacity: 1;
  color: rgb(18 183 106 / var(--tw-text-opacity, 1));
}
.hover\\:text-success-600:hover {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity, 1));
}
.hover\\:text-success-700:hover {
  --tw-text-opacity: 1;
  color: rgb(2 122 72 / var(--tw-text-opacity, 1));
}
.hover\\:text-success-800:hover {
  --tw-text-opacity: 1;
  color: rgb(5 96 58 / var(--tw-text-opacity, 1));
}
.hover\\:text-success-900:hover {
  --tw-text-opacity: 1;
  color: rgb(5 79 49 / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-100:hover {
  --tw-text-opacity: 1;
  color: rgb(254 240 199 / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-200:hover {
  --tw-text-opacity: 1;
  color: rgb(254 223 137 / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-25:hover {
  --tw-text-opacity: 1;
  color: rgb(255 252 245 / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-300:hover {
  --tw-text-opacity: 1;
  color: rgb(254 200 75 / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-400:hover {
  --tw-text-opacity: 1;
  color: rgb(253 176 34 / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-50:hover {
  --tw-text-opacity: 1;
  color: rgb(255 250 235 / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-500:hover {
  --tw-text-opacity: 1;
  color: rgb(247 144 9 / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-700:hover {
  --tw-text-opacity: 1;
  color: rgb(181 71 8 / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-800:hover {
  --tw-text-opacity: 1;
  color: rgb(147 55 13 / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-900:hover {
  --tw-text-opacity: 1;
  color: rgb(122 46 14 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-60:hover {
  opacity: 0.6;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.focus\\:z-10:focus {
  z-index: 10;
}
.focus\\:border-brand-700:focus {
  --tw-border-opacity: 1;
  border-color: rgb(65 131 198 / var(--tw-border-opacity, 1));
}
.focus\\:border-gray-300:focus {
  --tw-border-opacity: 1;
  border-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
}
.focus\\:bg-light:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:outline-0:focus {
  outline-width: 0px;
}
.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(46 144 250 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-gray-100:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 245 245 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:border-brand-500:focus-visible {
  --tw-border-opacity: 1;
  border-color: rgb(119 178 237 / var(--tw-border-opacity, 1));
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:bg-error-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray-100:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray-200:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-success-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 243 / var(--tw-bg-opacity, 1));
}
.disabled\\:text-blue-100:disabled {
  --tw-text-opacity: 1;
  color: rgb(209 233 255 / var(--tw-text-opacity, 1));
}
.disabled\\:text-error-200:disabled {
  --tw-text-opacity: 1;
  color: rgb(254 205 202 / var(--tw-text-opacity, 1));
}
.disabled\\:text-gray-400:disabled {
  --tw-text-opacity: 1;
  color: rgb(164 167 174 / var(--tw-text-opacity, 1));
}
.disabled\\:text-success-200:disabled {
  --tw-text-opacity: 1;
  color: rgb(166 244 197 / var(--tw-text-opacity, 1));
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.group:hover .group-hover\\:rotate-\\[360deg\\] {
  --tw-rotate: 360deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.data-\\[checked\\]\\:bg-brand-700[data-checked] {
  --tw-bg-opacity: 1;
  background-color: rgb(65 131 198 / var(--tw-bg-opacity, 1));
}
.data-\\[focus\\]\\:bg-brand-700\\/10[data-focus] {
  background-color: rgb(65 131 198 / 0.1);
}
.data-\\[selected\\]\\:bg-brand-700[data-selected] {
  --tw-bg-opacity: 1;
  background-color: rgb(65 131 198 / var(--tw-bg-opacity, 1));
}
.data-\\[selected\\]\\:text-light[data-selected] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.data-\\[closed\\]\\:opacity-0[data-closed] {
  opacity: 0;
}
.group[data-checked] .group-data-\\[checked\\]\\:translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-open] .group-data-\\[open\\]\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (prefers-reduced-motion: reduce) {

  @keyframes spin {

    to {
      transform: rotate(360deg);
    }
  }

  .motion-reduce\\:animate-\\[spin_1\\.5s_linear_infinite\\] {
    animation: spin 1.5s linear infinite;
  }
}
@media (min-width: 576px) {

  .sm\\:top-\\[137px\\] {
    top: 137px;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:\\!mb-4 {
    margin-bottom: 1rem !important;
  }

  .sm\\:\\!mb-6 {
    margin-bottom: 1.5rem !important;
  }

  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .sm\\:ml-3 {
    margin-left: 0.75rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-80 {
    height: 20rem;
  }

  .sm\\:h-\\[calc\\(100dvh-105px\\)\\] {
    height: calc(100dvh - 105px);
  }

  .sm\\:\\!w-full {
    width: 100% !important;
  }

  .sm\\:w-1\\/2 {
    width: 50%;
  }

  .sm\\:w-2\\/3 {
    width: 66.666667%;
  }

  .sm\\:w-\\[350px\\] {
    width: 350px;
  }

  .sm\\:w-\\[460px\\] {
    width: 460px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:min-w-\\[150px\\] {
    min-width: 150px;
  }

  .sm\\:min-w-\\[200px\\] {
    min-width: 200px;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:p-10 {
    padding: 2.5rem;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-\\[14px\\] {
    padding: 14px;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:text-center {
    text-align: center;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:leading-\\[44px\\] {
    line-height: 44px;
  }
}
@media (min-width: 768px) {

  .md\\:sticky {
    position: sticky;
  }

  .md\\:end-4 {
    inset-inline-end: 1rem;
  }

  .md\\:start-4 {
    inset-inline-start: 1rem;
  }

  .md\\:top-0 {
    top: 0px;
  }

  .md\\:top-4 {
    top: 1rem;
  }

  .md\\:top-5 {
    top: 1.25rem;
  }

  .md\\:top-\\[138px\\] {
    top: 138px;
  }

  .md\\:top-\\[143px\\] {
    top: 143px;
  }

  .md\\:top-\\[208px\\] {
    top: 208px;
  }

  .md\\:top-\\[280px\\] {
    top: 280px;
  }

  .md\\:order-none {
    order: 0;
  }

  .md\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .md\\:-mx-2 {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .md\\:-mx-2\\.5 {
    margin-left: -0.625rem;
    margin-right: -0.625rem;
  }

  .md\\:-mx-3 {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .md\\:mb-4 {
    margin-bottom: 1rem;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:mb-8 {
    margin-bottom: 2rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-10 {
    height: 2.5rem;
  }

  .md\\:h-12 {
    height: 3rem;
  }

  .md\\:h-24 {
    height: 6rem;
  }

  .md\\:h-5 {
    height: 1.25rem;
  }

  .md\\:h-6 {
    height: 1.5rem;
  }

  .md\\:h-\\[calc\\(100dvh-65px\\)\\] {
    height: calc(100dvh - 65px);
  }

  .md\\:h-\\[calc\\(100vh-250px\\)\\] {
    height: calc(100vh - 250px);
  }

  .md\\:\\!w-\\[160px\\] {
    width: 160px !important;
  }

  .md\\:\\!w-\\[180px\\] {
    width: 180px !important;
  }

  .md\\:\\!w-\\[190px\\] {
    width: 190px !important;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-10 {
    width: 2.5rem;
  }

  .md\\:w-5 {
    width: 1.25rem;
  }

  .md\\:w-6 {
    width: 1.5rem;
  }

  .md\\:w-\\[200px\\] {
    width: 200px;
  }

  .md\\:w-\\[210px\\] {
    width: 210px;
  }

  .md\\:w-\\[284px\\] {
    width: 284px;
  }

  .md\\:w-\\[360px\\] {
    width: 360px;
  }

  .md\\:w-\\[375px\\] {
    width: 375px;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:w-\\[86px\\] {
    width: 86px;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:w-fit {
    width: fit-content;
  }

  .md\\:min-w-10 {
    min-width: 2.5rem;
  }

  .md\\:min-w-\\[284px\\] {
    min-width: 284px;
  }

  .md\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .md\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .md\\:flex-grow-0 {
    flex-grow: 0;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-normal {
    justify-content: normal;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-1 {
    gap: 0.25rem;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:gap-x-3 {
    column-gap: 0.75rem;
  }

  .md\\:overflow-x-hidden {
    overflow-x: hidden;
  }

  .md\\:text-wrap {
    text-wrap: wrap;
  }

  .md\\:text-nowrap {
    text-wrap: nowrap;
  }

  .md\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .md\\:rounded-none {
    border-radius: 0px;
  }

  .md\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .md\\:border {
    border-width: 1px;
  }

  .md\\:border-b {
    border-bottom-width: 1px;
  }

  .md\\:border-r {
    border-right-width: 1px;
  }

  .md\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .md\\:p-3 {
    padding: 0.75rem;
  }

  .md\\:p-4 {
    padding: 1rem;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:pl-4 {
    padding-left: 1rem;
  }

  .md\\:pl-6 {
    padding-left: 1.5rem;
  }

  .md\\:pr-0 {
    padding-right: 0px;
  }

  .md\\:pr-6 {
    padding-right: 1.5rem;
  }

  .md\\:ps-8 {
    padding-inline-start: 2rem;
  }

  .md\\:pt-7 {
    padding-top: 1.75rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:leading-\\[32px\\] {
    line-height: 32px;
  }

  .md\\:leading-\\[38px\\] {
    line-height: 38px;
  }

  .md\\:shadow-box {
    --tw-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.12);
    --tw-shadow-colored: 0px 12px 24px 0px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
@media (min-width: 992px) {

  .lg\\:top-0 {
    top: 0px;
  }

  .lg\\:top-\\[70px\\] {
    top: 70px;
  }

  .lg\\:top-\\[80px\\] {
    top: 80px;
  }

  .lg\\:top-\\[86px\\] {
    top: 86px;
  }

  .lg\\:order-1 {
    order: 1;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:order-3 {
    order: 3;
  }

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .lg\\:-mt-8 {
    margin-top: -2rem;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:mb-4 {
    margin-bottom: 1rem;
  }

  .lg\\:mb-8 {
    margin-bottom: 2rem;
  }

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-7 {
    height: 1.75rem;
  }

  .lg\\:h-\\[calc\\(100dvh-192px\\)\\] {
    height: calc(100dvh - 192px);
  }

  .lg\\:h-\\[calc\\(100vh-240px\\)\\] {
    height: calc(100vh - 240px);
  }

  .lg\\:h-dvh {
    height: 100dvh;
  }

  .lg\\:h-screen {
    height: 100vh;
  }

  .lg\\:w-1\\/3 {
    width: 33.333333%;
  }

  .lg\\:w-7 {
    width: 1.75rem;
  }

  .lg\\:w-\\[1320px\\] {
    width: 1320px;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:min-w-\\[200px\\] {
    min-width: 200px;
  }

  .lg\\:min-w-\\[260px\\] {
    min-width: 260px;
  }

  .lg\\:min-w-\\[300px\\] {
    min-width: 300px;
  }

  .lg\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .lg\\:flex-1 {
    flex: 1 1;
  }

  .lg\\:shrink-0 {
    flex-shrink: 0;
  }

  .lg\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-rows-\\[auto_auto_auto\\] {
    grid-template-rows: auto auto auto;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:whitespace-normal {
    white-space: normal;
  }

  .lg\\:rounded-none {
    border-radius: 0px;
  }

  .lg\\:border {
    border-width: 1px;
  }

  .lg\\:border-0 {
    border-width: 0px;
  }

  .lg\\:border-y-0 {
    border-top-width: 0px;
    border-bottom-width: 0px;
  }

  .lg\\:border-b {
    border-bottom-width: 1px;
  }

  .lg\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .lg\\:border-r {
    border-right-width: 1px;
  }

  .lg\\:bg-brand-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(86 151 217 / var(--tw-bg-opacity, 1));
  }

  .lg\\:p-4 {
    padding: 1rem;
  }

  .lg\\:p-5 {
    padding: 1.25rem;
  }

  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .lg\\:pb-3 {
    padding-bottom: 0.75rem;
  }

  .lg\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .lg\\:pt-0 {
    padding-top: 0px;
  }

  .lg\\:pt-4 {
    padding-top: 1rem;
  }

  .lg\\:pt-6 {
    padding-top: 1.5rem;
  }

  .lg\\:pt-8 {
    padding-top: 2rem;
  }

  .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:text-light {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }

  .lg\\:hover\\:bg-brand-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(65 131 198 / var(--tw-bg-opacity, 1));
  }

  .lg\\:hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}
@media (min-width: 1240px) {

  .xl\\:top-0 {
    top: 0px;
  }

  .xl\\:top-\\[70px\\] {
    top: 70px;
  }

  .xl\\:-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .xl\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .xl\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .xl\\:mb-4 {
    margin-bottom: 1rem;
  }

  .xl\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .xl\\:inline {
    display: inline;
  }

  .xl\\:h-8 {
    height: 2rem;
  }

  .xl\\:w-1\\/4 {
    width: 25%;
  }

  .xl\\:w-6 {
    width: 1.5rem;
  }

  .xl\\:w-8 {
    width: 2rem;
  }

  .xl\\:w-\\[400px\\] {
    width: 400px;
  }

  .xl\\:w-auto {
    width: auto;
  }

  .xl\\:max-w-52 {
    max-width: 13rem;
  }

  .xl\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-rows-\\[auto_auto_auto\\] {
    grid-template-rows: auto auto auto;
  }

  .xl\\:flex-col {
    flex-direction: column;
  }

  .xl\\:gap-1 {
    gap: 0.25rem;
  }

  .xl\\:gap-2 {
    gap: 0.5rem;
  }

  .xl\\:gap-3 {
    gap: 0.75rem;
  }

  .xl\\:p-3 {
    padding: 0.75rem;
  }

  .xl\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .xl\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .xl\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .xl\\:pb-4 {
    padding-bottom: 1rem;
  }

  .xl\\:pb-8 {
    padding-bottom: 2rem;
  }

  .xl\\:pt-8 {
    padding-top: 2rem;
  }

  .xl\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .xl\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1400px) {

  .min-\\[1400px\\]\\:h-12 {
    height: 3rem;
  }

  .min-\\[1400px\\]\\:w-12 {
    width: 3rem;
  }
}
@media (min-width: 1476px) {

  .xxl\\:m-0 {
    margin: 0px;
  }

  .xxl\\:flex-row {
    flex-direction: row;
  }

  .xxl\\:gap-3 {
    gap: 0.75rem;
  }

  .xxl\\:gap-4 {
    gap: 1rem;
  }

  .xxl\\:\\!px-12 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  .xxl\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}
@media (prefers-color-scheme: dark) {

  .dark\\:text-gray-200 {
    --tw-text-opacity: 1;
    color: rgb(233 234 235 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-gray-500 {
    --tw-text-opacity: 1;
    color: rgb(113 118 128 / var(--tw-text-opacity, 1));
  }
}
@media print {

  .print\\:block {
    display: block;
  }

  .print\\:flex {
    display: flex;
  }

  .print\\:hidden {
    display: none;
  }

  .print\\:h-screen {
    height: 100vh;
  }

  .print\\:w-screen {
    width: 100vw;
  }

  .print\\:rotate-180 {
    --tw-rotate: 180deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .print\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .print\\:items-center {
    align-items: center;
  }

  .print\\:justify-center {
    justify-content: center;
  }

  .print\\:whitespace-normal {
    white-space: normal;
  }

  .print\\:rounded-br-none {
    border-bottom-right-radius: 0px;
  }
}
.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none::-webkit-inner-spin-button {
  appearance: none;
}
.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none::-webkit-outer-spin-button {
  appearance: none;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}
.\\[\\&\\>\\*\\]\\:px-1>* {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.\\[\\&\\>\\*\\]\\:px-1\\.5>* {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.\\[\\&\\>\\*\\]\\:px-2>* {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
@media (min-width: 768px) {

  .\\[\\&\\>\\*\\]\\:md\\:px-2\\.5>* {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .md\\:\\[\\&\\>\\*\\]\\:px-2>* {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:\\[\\&\\>\\*\\]\\:px-3>* {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}
@media (min-width: 1240px) {

  .\\[\\&\\>\\*\\]\\:xl\\:px-4>* {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/global.scss","webpack://./src/assets/scss/_form.scss"],"names":[],"mappings":"AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;EAAA;EAAA,gCAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,mCAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,eAAA;IAAA;EAAA;AAAA;EAAA;EAAA,kBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA;AAAA;EAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;EAAA;;EAAA;IAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,eAAA;IAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA;EAAA;AAAA;EAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,mBAAA;IAAA,iBAAA;IAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA;EAAA;AAAA;EAAA;EAAA,uBAAA;EAAA,eAAA;EAAA,mBAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,mBAAA;IAAA,mBAAA;IAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,iBAAA;IAAA;EAAA;AAAA;EAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,eAAA;IAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA;EAAA;AAAA;EAAA;EAAA,qBAAA;EAAA,eAAA;EAAA,mBAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,sBAAA;IAAA,mBAAA;IAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,mBAAA;IAAA;EAAA;AAAA;EAAA;EAAA,qBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA;AAAA;EAAA;;EAAA;IAAA;EAAA;AAAA;EAAA;;EAAA;IAAA,eAAA;IAAA;EAAA;AAAA;EAAA;EAAA;AAAA;EAAA;;EAAA;IAAA;EAAA;AAAA;EAAA;;EAAA,wBAAA;EAAA,0BAAA;EAAA;AAAA;EAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,gBAAA;EAAA;AAAA;EAAA;EAAA,gBAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA;AAAA;EAAA;EAAA,gBAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,eAAA;EAAA,gBAAA;EAAA;AAAA;EAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA;AAAA;EAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA;AAAA;EAAA;EAAA,gBAAA;EAAA;AAAA;EAAA;EAAA,iBAAA;EAAA,sBAAA;EAAA;AAAA;EAAA;EAAA,sBAAA;EAAA,kBAAA;EAAA;AAAA;EAAA;EAAA,kBAAA;EAAA;AAAA;AACA;EAAA,WAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AACA;EAAA,kBAAA;EAAA,UAAA;EAAA,WAAA;EAAA,UAAA;EAAA,YAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,QAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,cAAA;EAAA;AAAA;AAAA;EAAA,aAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,mCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;UAAA;AAAA;AAAA;EAAA,wBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,gEAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,mCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+CAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,kDAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,kDAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,yDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,wJAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;ACFA,gDAAA;AAEE;EAAA,cAAA;EAAA;AAAA;;AAGF;EACE,yDAAA;EACA,2BAAA;EAAA,4BAAA;AD2FF;;ACvFE;EAAA,2BAAA;EAAA,4BAAA;EACA;AADA;AAEA;EACE,0BAAA;AD4FJ;;ACxFA;EACE,yDAAA;EACA,2BAAA;EAAA,4BAAA;AD2FF;;ACvFE;EAAA,kBAAA;EAAA,QAAA;EAAA,YAAA;EAAA,aAAA;EAAA,sBAAA;EAAA,+LAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA,cAAA;IAAA,WAAA;IAAA,qBAAA;IAAA,sBAAA;IAAA,mBAAA;IAAA;EAAA;AAAA;AAEE;EAAA,uBAAA;EAAA,4BAAA;EAAA,sBAAA;EAAA;AAAA;AAGA;EAAA;AAAA;;AAKF;EACE,gCAAA;AD0FJ;;ACpFI;EAAA,qBAAA;EAAA,iBAAA;EAAA,sBAAA;EAAA,4DAAA;EAAA,kBAAA;EAAA,4DAAA;EAAA,eAAA;EAAA,mBAAA;EAAA,gBAAA;EACA;AADA;AAGE;EAAA,sBAAA;EAAA;AAAA;AAGA;EAAA,sBAAA;EAAA;AAAA;AAGA;EAAA,sBAAA;EAAA,4DAAA;EAAA,kBAAA;EAAA,4DAAA;EAAA,kDAAA;EAAA,6DAAA;EAAA;AAAA;AAEE;EAAA,oBAAA;EAAA;AAAA;AAKJ;EAAA,mBAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA;AAAA;AAGA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;AAGA;EAAA,WAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,iBAAA;EAAA,sBAAA;EAAA,4DAAA;EAAA,kBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,6DAAA;EAAA;AAAA;AAEE;EAAA,oBAAA;EAAA,uBAAA;EAAA,kBAAA;EAAA;AAAA;;AAKN,6BAAA;AAEE;;;EAGE,oCAAA;EACA,gCAAA;ADsFJ;ACpFE;;;;EAIE,yBAAA;EACA,gBAAA;ADsFJ;;AClFE;;;EAGE,oCAAA;EACA,gCAAA;ADqFJ;ACnFE;;;;EAIE,yBAAA;EACA,gBAAA;ADqFJ;;ACjFE;;;EAGE,oCAAA;EACA,gCAAA;ADoFJ;AClFE;;;;EAIE,yBAAA;EACA,gBAAA;ADoFJ;;AChFE;;;EAGE,oCAAA;EACA,gCAAA;ADmFJ;ACjFE;;;;EAIE,yBAAA;EACA,gBAAA;ADmFJ;;AA5MA,2DAAA;AACA;EACE,2CACE;AA8MJ;;AArMA;EACE,oCAAA;EACA,yCAAA;AAwMF;;AArMA;EACE,oCAAA,EAAA,yBAAA;AAwMF;;AArMA;EACE,yBAAA,EAAA,cAAA;AAwMF;;AAnME;EAAA,iBAAA;EAAA,sBAAA;EAAA,4DAAA;EAAA,kBAAA;EAAA,4DAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA,mBAAA;IAAA;EAAA;AAAA;;AAEF;EACE,mBAAA;AAwMF;;AArME;EAAA,iBAAA;EAAA,sBAAA;EAAA,4DAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAGA;EAAA;AAAA;;AAGA;EAAA;AAAA;;AAIA;EACE,gBAAA;AA0MJ;AAxMC;EACG,qBAAA;AA0MJ;AAhQA;EAAA,mBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,+BAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,gCAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,8BAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,mBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,mBAgQA;EAhQA;AAgQA;AAhQA;;EAAA;;IAAA;MAAA;IAgQA;EAAA;;EAhQA;IAAA;EAgQA;AAAA;AAhQA;;EAAA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,kBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,qBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,mBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,oBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,eAgQA;IAhQA;EAgQA;;EAhQA;IAAA,mBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,mBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;AAAA;AAhQA;;EAAA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,oBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,sBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,qBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,gBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,gBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,kBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,iBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,qBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,kBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,qBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,gBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,mBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,iBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,iBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,mBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,kBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,eAgQA;IAhQA;EAgQA;;EAhQA;IAAA,mBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,mBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,kBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,kDAgQA;IAhQA,6DAgQA;IAhQA;EAgQA;AAAA;AAhQA;;EAAA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,qBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,qBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,kBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,oBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,oBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,oBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,eAgQA;IAhQA;EAgQA;;EAhQA;IAAA,mBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,kBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,oBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,kBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,oBAgQA;IAhQA;EAgQA;AAAA;AAhQA;;EAAA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,kBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,gBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,oBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,kBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,iBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,iBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,mBAgQA;IAhQA;EAgQA;AAAA;AAhQA;;EAAA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;AAAA;AAhQA;;EAAA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,6BAgQA;IAhQA;EAgQA;;EAhQA;IAAA,qBAgQA;IAhQA;EAgQA;AAAA;AAhQA;;EAAA;IAAA,oBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,oBAgQA;IAhQA;EAgQA;AAAA;AAhQA;;EAAA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA,mBAgQA;IAhQA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;;EAhQA;IAAA;EAgQA;AAAA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,qBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;;EAAA;IAAA,sBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,oBAgQA;IAhQA;EAgQA;;EAhQA;IAAA,qBAgQA;IAhQA;EAgQA;AAAA;AAhQA;;EAAA;IAAA,kBAgQA;IAhQA;EAgQA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@import 'common';\n@import 'form';\n\n/* Apply styles to the span representing the radio button */\ninput[type='radio'] + label .radio-span {\n  transition:\n    background 0.2s,\n    transform 0.2s;\n}\n\n// input[type='radio'] + label .radio-span:hover,\n// input[type='radio'] + label:hover .radio-span {\n//   transform: scale(1.2);\n// }\n\ninput[type='radio']:checked + label .radio-span {\n  background-color: #5697d9 !important;\n  box-shadow: 0px 0px 0px 4px #f1f7fd inset;\n}\n\ninput[type='radio']:checked + label .radio-span span {\n  background-color: #5697d9 !important; /* bg-blue when checked */\n}\n\ninput[type='radio']:checked + label {\n  color: #5697d9 !important; /* text-blue */\n}\n\n\n.table-common thead th {\n  @apply bg-[#bbdbfa] border border-gray-200 text-black lg:text-sm;\n}\n.table-common tbody tr:nth-child(even){\n  background: #f6fbff;\n}\n.table-common tbody tr td {\n  @apply px-3 py-2.5 border border-gray-200 first:border-l-0 last:border-r-0;\n}\n.table-common tbody tr:first-child td {\n  @apply border-t-0;\n}\n.table-common tbody tr:last-child td {\n  @apply border-b-0;\n}\n\n.manpower-select{\n  .custom-select__value-container{\n    min-height: 35px;\n  }\n .custom-select__menu{\n    z-index: 4!important;\n  }\n}\n// .absence-select{\n//   .custom-select__menu-portal,.custom-select__menu{\n//   z-index: 101010!important;\n// }\n// }","/* Hide scrollbar for Chrome, Safari and Opera */\n.input {\n  @apply block w-full;\n}\n\ninput[type='checkbox']:checked {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='10' viewBox='0 0 12 10' fill='none'%3E%3Cpath d='M1 5L4.33333 8L11 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  @apply bg-no-repeat bg-center;\n}\n\ninput[type='radio'] {\n  @apply bg-no-repeat bg-center;\n  background-size: 14px auto;\n  &.check-sm {\n    background-size: 10px auto;\n  }\n}\n\ninput[type='radio']:checked {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8' fill='none'%3E%3Ccircle cx='4' cy='4' r='4' fill='white'/%3E%3C/svg%3E\");\n  @apply bg-no-repeat bg-center;\n}\n\n.icon-input {\n  @apply w-10 h-8 md:w-12 md:h-10 px-2 md:px-3 py-1.5 md:py-2 absolute top-1/2 -translate-y-1/2;\n  &.icon-start {\n    @apply start-0 border-e border-gray-200;\n  }\n  &.icon-end {\n    @apply end-0;\n  }\n}\n\n.active-select {\n  .custom-select__control {\n    border-color: #d92d20 !important;\n  }\n}\n\n.custom-select-container {\n  .custom-select__control {\n    @apply bg-light border rounded-lg text-base font-medium border-gray-300;\n    box-shadow: none;\n    &:hover {\n      @apply border-gray-300;\n    }\n    &.custom-select__control--is-focused {\n      @apply border-gray-300;\n    }\n    &.custom-select__control--menu-is-open {\n      @apply border-gray-300 bg-light shadow-box;\n      .custom-select__single-value {\n        @apply text-gray-900;\n      }\n    }\n  }\n  .custom-select__value-container {\n    @apply px-3.5 min-h-11 rounded-lg;\n  }\n  .custom-select__placeholder {\n    @apply text-gray-500 font-normal;\n  }\n  .custom-select__menu {\n    @apply m-0 z-10 text-gray-700 my-1 bg-light font-medium border border-gray-200 shadow-box rounded-lg;\n    .custom-select__option {\n      @apply py-1 px-4;\n    }\n  }\n}\n\n/* Theming for CustomSelect */\n.custom-select-container.theme-blue {\n  .custom-select__control,\n  .custom-select__control.custom-select__control--is-focused,\n  .custom-select__control.custom-select__control--menu-is-open {\n    background-color: #5697d9 !important;\n    border-color: #5697d9 !important;\n  }\n  .custom-select__single-value,\n  .custom-select__placeholder,\n  .custom-select__indicators,\n  .custom-select__indicator {\n    color: #ffffff !important;\n    font-weight: 600;\n  }\n}\n.custom-select-container.theme-red {\n  .custom-select__control,\n  .custom-select__control.custom-select__control--is-focused,\n  .custom-select__control.custom-select__control--menu-is-open {\n    background-color: #fee2e2 !important;\n    border-color: #fecaca !important;\n  }\n  .custom-select__single-value,\n  .custom-select__placeholder,\n  .custom-select__indicators,\n  .custom-select__indicator {\n    color: #b91c1c !important;\n    font-weight: 600;\n  }\n}\n.custom-select-container.theme-yellow {\n  .custom-select__control,\n  .custom-select__control.custom-select__control--is-focused,\n  .custom-select__control.custom-select__control--menu-is-open {\n    background-color: #fef0c7 !important;\n    border-color: #fedf89 !important;\n  }\n  .custom-select__single-value,\n  .custom-select__placeholder,\n  .custom-select__indicators,\n  .custom-select__indicator {\n    color: #b54708 !important;\n    font-weight: 600;\n  }\n}\n.custom-select-container.theme-green {\n  .custom-select__control,\n  .custom-select__control.custom-select__control--is-focused,\n  .custom-select__control.custom-select__control--menu-is-open {\n    background-color: #d1fadf !important;\n    border-color: #a6f4c5 !important;\n  }\n  .custom-select__single-value,\n  .custom-select__placeholder,\n  .custom-select__indicators,\n  .custom-select__indicator {\n    color: #027a48 !important;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
